<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aQTG0b/tc-custom/9781429954921.jpg?1721404279433" alt="This image is the cover for the book Deep Black: Payback"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deep Black: Payback
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>RECRUITED:<br/></i>A crack team of cover agents.<br/></b>Word is out to ex-Marine sniper Charlie Dean and his team of the National Security Agency: Infiltrate the highest stratum of Peruvian political power and derail a renegade general from acing an election. All Dean has to do is find a way inside an impenetrable bank vault protected by armed guards round the clock–it's all in a day's work for the men and women of Deep Black.<br/><br/><b><i>ENGAGED:</i></b><br/><b>A violent political coup</b><br/>But things get complicated when Dean and company discover the renegade general's second plot. The military madman's ruse—a nuclear weapon he claims is in the hands of Marxist guerillas, a bomb that only he can rescue…and control.<br/><br/><b><i>IGNITED:</i></b><br/><b>A devastating terrorist plot.</b><br/>When the general and his plot are exposed, the NSA concludes the greatest threat is over. But in fact, it's only just beginning…in Stephen Coonts' <i>Deep Black: Payback, </i>cowritten with  Jim DeFelice.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen Coonts, Jim DeFelice
      </h2>
      
      <p class="authorDescription body article"><p>Stephen Coonts (b. 1946) was born in Buckhannon, West Virginia. He is the <i>New York Times</i> bestselling author of twenty-eight thriller and nonfiction titles, including <i>The Intruders</i>,<i> The Minotaur</i>,<i> Under Siege</i>,<i> The Red Horseman</i>,and<i> The Cannibal Queen</i>. A combat pilot in the Vietnam War, Coonts&rsquo;s technical knowledge of aviation and warfare has contributed to the enormous popularity of his novels. The author currently divides his time between his home in Colorado and a farm in West Virginia, where he does much of his writing.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Macmillan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5614104c